{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Itsatsi",
    "pasteAsPlaintext": "Itsatsi testu arrunt gisa",
    "pasteCharts": "Itsatsi grafikoak",
    "chartType_bar": "Barra-diagrama",
    "chartType_line": "Lerro-diagrama",
    "chartType_radar": "Radar-diagrama",
    "chartType_plaintext": "Testu soila",
    "selectAll": "Hautatu dena",
    "multiSelect": "Gehitu elementua hautapenera",
    "moveCanvas": "Mugitu oihala",
    "cut": "Ebaki",
    "copy": "Kopiatu",
    "copyAsPng": "Kopiatu arbelera PNG gisa",
    "copyAsSvg": "Kopiatu arbelera SVG gisa",
    "copyText": "Kopiatu arbelera testu gisa",
    "copySource": "Kopiatu jatorria arbelean",
    "convertToCode": "Kodera bihurtu",
    "bringForward": "Ekarri aurrerago",
    "sendToBack": "Eraman atzera",
    "bringToFront": "Ekarri aurrera",
    "sendBackward": "Eraman atzerago",
    "delete": "Ezabatu",
    "copyStyles": "Kopiatu estiloak",
    "pasteStyles": "Itsatsi estiloak",
    "stroke": "Marra",
    "changeStroke": "Marraren kolorea aldatu",
    "background": "Atzeko planoa",
    "changeBackground": "Atzealdeko kolorea aldatu",
    "fill": "Bete",
    "strokeWidth": "Marraren zabalera",
    "strokeStyle": "Marraren estiloa",
    "strokeStyle_solid": "Solidoa",
    "strokeStyle_dashed": "Marratua",
    "strokeStyle_dotted": "Puntukatua",
    "sloppiness": "Marraren trazoa",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Opakotasuna",
    "textAlign": "Testuaren lerrokapena",
    "edges": "Ertzak",
    "sharp": "Ertz bizia",
    "round": "Borobildua",
    "arrowheads": "Gezi-puntak",
    "arrowhead_none": "Bat ere ez",
    "arrowhead_arrow": "Gezia",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Zirkulua",
    "arrowhead_circle_outline": "Zirkulua (eskema)",
    "arrowhead_triangle": "Hirukia",
    "arrowhead_triangle_outline": "Triangelua (eskema)",
    "arrowhead_diamond": "Erromboa",
    "arrowhead_diamond_outline": "Erromboa (eskema)",
    "arrowhead_crowfoot_many": "Bele oina (hainbat)",
    "arrowhead_crowfoot_one": "Bele oina (bat)",
    "arrowhead_crowfoot_one_or_many": "Bele oina (bat edo hainbat)",
    "arrowhead_cardinality_one": "Kardinalitatea (bat)",
    "arrowhead_cardinality_many": "Kardinalitatea (hainbat)",
    "arrowhead_cardinality_one_or_many": "Kardinalitatea (bat edo hainbat)",
    "arrowhead_cardinality_exactly_one": "Kardinalitatea (zehazki bat)",
    "arrowhead_cardinality_zero_or_one": "Kardinalitatea (zero edo bat)",
    "arrowhead_cardinality_zero_or_many": "Kardinalitatea (zero edo hainbat)",
    "more_options": "Aukera gehiago",
    "cardinality": "Kardinalitatea",
    "arrowtypes": "Gezi mota",
    "arrowtype_sharp": "Gezi zorrotza",
    "arrowtype_round": "Gezi kurbaduna",
    "arrowtype_elbowed": "Ukondo gezia",
    "fontSize": "Letra-tamaina",
    "fontFamily": "Letra-tipoa",
    "addWatermark": "Gehitu \"Excalidraw bidez egina\"",
    "handDrawn": "Eskuz marraztua",
    "normal": "Normala",
    "code": "Kodea",
    "small": "Txikia",
    "medium": "Ertaina",
    "large": "Handia",
    "veryLarge": "Oso handia",
    "solid": "Solidoa",
    "hachure": "Itzalduna",
    "zigzag": "Sigi-saga",
    "crossHatch": "Marraduna",
    "thin": "Mehea",
    "bold": "Lodia",
    "left": "Ezkerrean",
    "center": "Erdian",
    "right": "Eskuinean",
    "extraBold": "Oso lodia",
    "architect": "Arkitektoa",
    "artist": "Artista",
    "cartoonist": "Marrazkilaria",
    "fileTitle": "Fitxategi izena",
    "colorPicker": "Kolore-hautatzailea",
    "canvasColors": "Oihalean erabilita",
    "canvasBackground": "Oihalaren atzeko planoa",
    "drawingCanvas": "Marrazteko oihala",
    "clearCanvas": "Garbitu",
    "layers": "Geruzak",
    "actions": "Ekintzak",
    "language": "Hizkuntza",
    "liveCollaboration": "Zuzeneko elkarlana...",
    "duplicateSelection": "Bikoiztu",
    "untitled": "Izengabea",
    "name": "Izena",
    "yourName": "Zure izena",
    "madeWithExcalidraw": "Excalidraw bidez egina",
    "group": "Hautapena taldea bihurtu",
    "ungroup": "Desegin hautapenaren taldea",
    "collaborators": "Kolaboratzaileak",
    "you": "",
    "toggleGrid": "Txandakatu sareta",
    "loadingScene": "Eszena kargatzen…",
    "loadScene": "Fitxategitik kargatu",
    "align": "Lerrokatu",
    "alignTop": "Lerrokatu goian",
    "alignBottom": "Lerrokatu behean",
    "alignLeft": "Lerrokatu ezkerrean",
    "alignRight": "Lerrokatu eskuinean",
    "centerVertically": "Erdiratu bertikalki",
    "centerHorizontally": "Erdiratu horizontalki",
    "distributeHorizontally": "Banandu horizontalki",
    "distributeVertically": "Banandu bertikalki",
    "flipHorizontal": "Irauli horizontalki",
    "flipVertical": "Irauli bertikalki",
    "viewMode": "Ikuspegia",
    "share": "Partekatu",
    "showStroke": "Erakutsi marraren kolore-hautatzailea",
    "showBackground": "Erakutsi atzeko planoaren kolore-hautatzailea",
    "showFonts": "Erakutsi letra mota hautatzailea",
    "toggleTheme": "Gaia argia/iluna aktibatu",
    "theme": "Itxura",
    "decreaseFontSize": "Txikitu letra tamaina",
    "increaseFontSize": "Handitu letra tamaina",
    "unbindText": "Askatu testua",
    "bindText": "Lotu testua edukiontziari",
    "createContainerFromText": "Bilatu testua edukiontzi batean",
    "link": {
      "edit": "Editatu esteka",
      "editEmbed": "Editatu esteka kapsulagarria",
      "create": "Gehitu esteka",
      "label": "Esteka",
      "labelEmbed": "Esteka eta kapsula",
      "empty": "Ez da estekarik ezarri",
      "hint": "Idatzi edo itsatsi zure eskeka hemen",
      "goToElement": "Joan helburuko elementura"
    },
    "lineEditor": {
      "edit": "Editatu lerroa",
      "editArrow": "Gezia aldatu"
    },
    "polygon": {
      "breakPolygon": "Ireki poligonoa",
      "convertToPolygon": "Bihurtu poligono"
    },
    "elementLock": {
      "lock": "Blokeatu",
      "unlock": "Desblokeatu",
      "lockAll": "Blokeatu guztiak",
      "unlockAll": "Desblokeatu guztiak"
    },
    "sidebarLock": "Mantendu alboko barra irekita",
    "selectAllElementsInFrame": "Hautatu markoko elementu guztiak",
    "removeAllElementsFromFrame": "Kendu markoko elementu guztiak",
    "eyeDropper": "Aukeratu kolorea oihaletik",
    "followUs": "Jarraitu gaitzazu",
    "discordChat": "Discord txata",
    "zoomToFitViewport": "Zoom ikuspegira",
    "zoomToFitSelection": "Zoom hautapenera",
    "zoomToFit": "Egin zoom elementu guztiak ikusteko",
    "installPWA": "Instalatu Excalidraw lokalean (PWA)",
    "autoResize": "Textu zabalera automatikoa aktibatu",
    "imageCropping": "Irudia moztea",
    "unCroppedDimension": "Moztu gabeko dimentsioa",
    "copyElementLink": "Kopiatu esteka objektura",
    "linkToElement": "Estekatu objektura",
    "wrapSelectionInFrame": "Bildu hautapena marko batean",
    "tab": "Tab",
    "shapeSwitch": "Aldatu forma",
    "preferences": "Hobespenak",
    "preferences_toolLock": "Erremintaren blokeoa",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "Gezi azala",
    "midpointSnapping": "Lotu erdiko puntuetara"
  },
  "elementLink": {
    "title": "Estekatu objektura",
    "desc": "Egin klik forma batean edo itsatsi esteka bat.",
    "notFound": "Estekatutako objektua ez da aurkitu oihalean."
  },
  "search": {
    "title": "Bilatu oihalean",
    "noMatch": "Ez da ezer aurkitu...",
    "singleResult": "emaitza",
    "multipleResults": "emaitzak",
    "placeholder": "Bilatu testua oihalean...",
    "frames": "Markoak",
    "texts": "Testuak"
  },
  "buttons": {
    "clearReset": "Garbitu oihala",
    "exportJSON": "Esportatu fitxategira",
    "exportImage": "Esportatu irudia...",
    "export": "Gorde hemen...",
    "copyToClipboard": "Kopiatu arbelera",
    "copyLink": "Kopiatu esteka",
    "save": "Gorde uneko fitxategian",
    "saveAs": "Gorde honela",
    "load": "Ireki",
    "getShareableLink": "Lortu partekatzeko esteka",
    "close": "Itxi",
    "selectLanguage": "Hautatu hizkuntza",
    "scrollBackToContent": "Joan atzera edukira",
    "zoomIn": "Handiagotu",
    "zoomOut": "Txikiagotu",
    "resetZoom": "Leheneratu zooma",
    "menu": "Menua",
    "done": "Egina",
    "edit": "Editatu",
    "undo": "Desegin",
    "redo": "Berregin",
    "createNewRoom": "Sortu gela berria",
    "fullScreen": "Pantaila osoa",
    "darkMode": "Modu iluna",
    "lightMode": "Modu argia",
    "systemMode": "Sistema modua",
    "zenMode": "Zen modua",
    "objectsSnapMode": "Atxiki objektuei",
    "exitZenMode": "Irten Zen modutik",
    "cancel": "Utzi",
    "clear": "Garbitu",
    "remove": "Kendu",
    "embed": "Aldatu kapsulatzea",
    "submit": "Bidali",
    "confirm": "Bai",
    "embeddableInteractionButton": "Egin klik elkar eragiteko"
  },
  "alerts": {
    "clearReset": "Honek oihal osoa garbituko du. Ziur zaude?",
    "couldNotCreateShareableLink": "Ezin izan da partekatzeko estekarik sortu.",
    "couldNotCreateShareableLinkTooBig": "Ezin izan da partekatzeko estekarik sortu: eszena handiegia da",
    "couldNotLoadInvalidFile": "Ezin izan da kargatu, fitxategiak ez du balio",
    "importBackendFailed": "Inportazioak huts egin du.",
    "cannotExportEmptyCanvas": "Ezin izan da oihal hutsa esportatu.",
    "couldNotCopyToClipboard": "Ezin izan da arbelean kopiatu.",
    "decryptFailed": "Ezin izan da deszifratu.",
    "uploadedSecurly": "Kargatzea muturretik muturrerako zifratze bidez ziurtatu da, hau da, Excalidraw zerbitzariak eta hirugarrenek ezin dutela edukia irakurri.",
    "loadSceneOverridePrompt": "Kanpoko marrazkia kargatzeak lehendik duzun edukia ordezkatuko du. Jarraitu nahi duzu?",
    "collabStopOverridePrompt": "Saioa gelditzeak lokalean gordetako zure aurreko marrazkia gainidatziko du. Ziur zaude?\n\n(Zure marrazki lokala mantendu nahi baduzu, itxi arakatzailearen fitxa.)",
    "imageDoesNotContainScene": "Irudi honek ez dirudi eszena daturik duenik. Eszena kapsulatzea gaitu al duzu esportazioan?",
    "cannotRestoreFromImage": "Ezin izan da eszena leheneratu irudi fitxategi honetatik",
    "invalidSceneUrl": "Ezin izan da eszena inportatu emandako URLtik. Gaizki eratuta dago edo ez du baliozko Excalidraw JSON daturik.",
    "invalidEncryptionKey": "Enkriptazio-gakoak 22 karaktere izan behar ditu. Zuzeneko lankidetza desgaituta dago.",
    "collabOfflineWarning": "Ez dago Interneteko konexiorik.\nZure aldaketak ez dira gordeko!",
    "localStorageQuotaExceeded": "Nabigatzailearen biltegiratze muga bete da. Aldaketak ez dira gordeko."
  },
  "errors": {
    "unsupportedFileType": "Onartu gabeko fitxategi mota.",
    "imageInsertError": "Ezin izan da irudia txertatu. Saiatu berriro geroago...",
    "fileTooBig": "Fitxategia handiegia da. Onartutako gehienezko tamaina {{maxSize}} da.",
    "svgImageInsertError": "Ezin izan da SVG irudia txertatu. SVG markak baliogabea dirudi.",
    "failedToFetchImage": "Ezin izan da irudia eskuratu.",
    "cannotResolveCollabServer": "Ezin izan da elkarlaneko zerbitzarira konektatu. Mesedez, berriro kargatu orria eta saiatu berriro.",
    "collabSaveFailed": "Ezin izan da backend datu-basean gorde. Arazoak jarraitzen badu, zure fitxategia lokalean gorde beharko zenuke zure lana ez duzula galtzen ziurtatzeko.",
    "collabSaveFailed_sizeExceeded": "Ezin izan da backend datu-basean gorde, ohiala handiegia dela dirudi. Fitxategia lokalean gorde beharko zenuke zure lana galtzen ez duzula ziurtatzeko.",
    "imageToolNotSupported": "Irudiak desgaituak daude.",
    "brave_measure_text_error": {
      "line1": "Brave arakatzailea erabiltzen ari zarela dirudi <bold>Blokeatu hatz-markak erasokorki</bold> ezarpena gaituta.",
      "line2": "Honek zure marrazkietako <bold>Testu-elementuak</bold> hautsi ditzake.",
      "line3": "Ezarpen hau desgaitzea gomendatzen dugu. <link>urrats hauek</link> jarrai ditzakezu hori nola egin jakiteko.",
      "line4": "Ezarpen hau desgaituz gero, testu-elementuen bistaratzea konpontzen ez bada, ireki <issueLink>arazo</issueLink> gure GitHub-en edo idatzi iezaguzu <discordLink>Discord</discordLink> helbidera"
    },
    "asyncPasteFailedOnRead": "Ezin izan da itsatsi (ezin izan da sistemaren arbeletik irakurri).",
    "asyncPasteFailedOnParse": "Ezin izan da itsatsi.",
    "copyToSystemClipboardFailed": "Ezin izan da arbelean kopiatu."
  },
  "toolBar": {
    "selection": "Hautapena",
    "lasso": "Lazo hautaketa",
    "image": "Txertatu irudia",
    "rectangle": "Laukizuzena",
    "diamond": "Diamantea",
    "ellipse": "Elipsea",
    "arrow": "Gezia",
    "line": "Lerroa",
    "freedraw": "Marraztu",
    "text": "Testua",
    "lock": "Mantendu aktibo hautatutako tresna marraztu ondoren",
    "penMode": "Luma modua - ukipena saihestu",
    "link": "Gehitu / Eguneratu esteka hautatutako forma baterako",
    "eraser": "Borragoma",
    "frame": "Marko tresna",
    "embeddable": "Web kapsulatzea",
    "laser": "Laser punteroa",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Eskua (panoratze tresna)",
    "extraTools": "Tresna gehiago",
    "convertElementType": "Aldatu forma mota"
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Laukizuzena",
    "diamond": "Erromboa",
    "ellipse": "Elipsea",
    "arrow": "Gezia",
    "line": "Lerroa",
    "freedraw": "Marrazketa librea",
    "text": "Testua",
    "image": "Irudia",
    "group": "Taldea",
    "frame": "Markoa",
    "embeddable": "Web kapsulatzea",
    "selection": "Hautapena",
    "iframe": "IFramea"
  },
  "headings": {
    "canvasActions": "Canvas ekintzak",
    "selectedShapeActions": "Hautatutako formaren ekintzak",
    "shapes": "Formak"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} bilaketa bertan behera uzteko",
    "canvasPanning": "Oihala mugitzeko heldu {{shortcut_1}} edo {{shortcut_2}} arrastatu bitartean edo erabili esku-tresna",
    "linearElement": "Egin klik hainbat puntu hasteko, arrastatu lerro bakarrerako",
    "arrowTool": "Egin klik puntuak egiteko, arrastatu lerro sinplea egiteko. Sakatu {{shortcut}} berriro gezi mota aldatzeko.",
    "arrowBindModifiers": "Heldu {{shortcut_1}} inguraketa desgaitzeko, edo {{shortcut_2}} puntu finko batean biltzeko",
    "freeDraw": "Egin klik eta arrastatu, askatu amaitutakoan",
    "text": "Aholkua: testua gehitu dezakezu edozein lekutan klik bikoitza eginez hautapen tresnarekin",
    "embeddable": "Egin klik eta arrastatu webgunea kapsulatzeko",
    "autoshape": "",
    "text_selected": "Klik bikoitza edo sakatu {{shortcut}} testua editatzeko",
    "text_editing": "Sakatu {{shortcut_1}} edo {{shortcut_2}} edizioa amaitzeko",
    "linearElementMulti": "Egin klik azken puntuan edo sakatu {{shortcut_1}} edo {{shortcut_2}} amaitzeko",
    "lockAngle": "Angelua mugatu dezakezu {{shortcut}} helduta",
    "resize": "Proportzioak mugatu ditzakezu {{shortcut_1}} helduta tamaina aldatzean, heldu {{shortcut_2}} erdigunetik tamaina aldatzeko",
    "resizeImage": "Libreki alda dezakezu tamaina {{shortcut_1}} helduta, heldu {{shortcut_2}} tamaina erdigunetik aldatzeko",
    "rotate": "Angeluak mugatu ditzakezu {{shortcut}} helduta biratzen duzun bitartean",
    "toggleArrowhead": "",
    "lineEditor_info": "Heldu {{shortcut_1}} eta egin klik bikoitza edo sakatu {{shortcut_2}} puntuak editatzeko",
    "lineEditor_line_info": "Egin klik bikoitza edo sakatu {{shortcut}} puntuak editatzeko",
    "lineEditor_pointSelected": "Sakatu {{shortcut_1}} puntua(k) kentzeko, {{shortcut_2}} bikoizteko edo arrastatu mugitzeko",
    "lineEditor_nothingSelected": "Hautatu puntu bate editatzeko (heldu {{shortcut_1}} gehiago hautatzeko), edo heldu {{shortcut_2}} eta egin klik puntu berriak gehitzeko",
    "bindTextToElement": "{{shortcut}} testua gehitzeko",
    "createFlowchart": "{{shortcut}} fluxu-diagrama sortzeko",
    "deepBoxSelect": "Heldu {{shortcut}} sakon hautatzeko eta arrastatzea saihesteko",
    "eraserRevert": "Heldu {{shortcut}} leheneratzeko ezabatzeko markatutako elementuak",
    "firefox_clipboard_write": "Ezaugarri hau \"dom.events.asyncClipboard.clipboardItem\" marka \"true\" gisa ezarrita gaitu daiteke. Firefox-en arakatzailearen banderak aldatzeko, bisitatu \"about:config\" orrialdera.",
    "disableSnapping": "Heldu {{shortcut}} doiketa desgaitzeko",
    "enterCropEditor": "Klik bikoitza irudian edo sakatu {{shortcut}} irudia mozteko",
    "leaveCropEditor": "Egin klik irudi kanpoan edo sakatu {{shortcut_1}} edo {{shortcut_2}} mozketa amaitzeko"
  },
  "canvasError": {
    "cannotShowPreview": "Ezin da oihala aurreikusi",
    "canvasTooBig": "Agian oihala handiegia da.",
    "canvasTooBigTip": "Aholkua: saiatu urrunen dauden elementuak pixka bat hurbiltzen."
  },
  "errorSplash": {
    "headingMain": "Errore bat aurkitu da. Saiatu <button>orria birkargatzen.</button>",
    "clearCanvasMessage": "Birkargatzea ez bada burutzen, saiatu <button>oihala garbitzen.</button>",
    "clearCanvasCaveat": " Honen ondorioz lana galduko da ",
    "trackedToSentry": "Identifikatzailearen errorea {{eventId}} gure sistemak behatu du.",
    "openIssueMessage": "Oso kontuz ibili gara zure eszenaren informazioa errorean ez sartzeko. Zure eszena pribatua ez bada, kontuan hartu gure <button>erroreen jarraipena egitea.</button> Sartu beheko informazioa kopiatu eta itsatsi bidez GitHub issue-n.",
    "sceneContent": "Eszenaren edukia:"
  },
  "shareDialog": {
    "or": "Edo"
  },
  "roomDialog": {
    "desc_intro": "Gonbidatu jendea zure marrazkira.",
    "desc_privacy": "Lasai, sesioa encriptatua dago eta erabat pribatua da. Gure zerbitzarian ere ezin da ikusi zure marrazkia.",
    "button_startSession": "Hasi saioa",
    "button_stopSession": "Itxi saioa",
    "desc_inProgressIntro": "Zuzeneko lankidetza saioa abian da.",
    "desc_shareLink": "Partekatu esteka hau elkarlanean aritu nahi duzun edonorekin:",
    "desc_exitSession": "Saioa ixteak aretotik deskonektatuko zaitu, baina eszenarekin lanean jarraitu ahal izango duzu lokalean. Kontuan izan honek ez diela beste pertsonei eragingo, eta euren bertsioan elkarlanean aritu ahal izango dira.",
    "shareTitle": "Sartu Excalidraw-en zuzeneko lankidetza-saio batean"
  },
  "errorDialog": {
    "title": "Errorea"
  },
  "progressDialog": {
    "title": "Gordetzen",
    "defaultMessage": "Gordetzek prestatzen..."
  },
  "exportDialog": {
    "disk_title": "Gorde diskoan",
    "disk_details": "Esportatu eszenaren datuak geroago inportatu ahal izango duzun fitxategi batan.",
    "disk_button": "Gorde fitxategian",
    "link_title": "Partekatzeko esteka",
    "link_details": "Esportatu irakurtzeko soilik moduko esteka.",
    "link_button": "Esportatu esteka",
    "excalidrawplus_description": "Gorde eszena zure Excalidraw+ laneko areara.",
    "excalidrawplus_button": "Esportatu",
    "excalidrawplus_exportError": "Une honetan ezin izan da esportatu Excalidraw+era..."
  },
  "helpDialog": {
    "blog": "Irakurri gure bloga",
    "click": "sakatu",
    "deepSelect": "Hautapen sakona",
    "deepBoxSelect": "Hautapen sakona egin laukizuzen bidez, eta saihestu arrastatzea",
    "createFlowchart": "Sortu diagrama-fluxu bat elementu generiko batetik abiatuta",
    "navigateFlowchart": "Nabigatu fluxu-diagramatik",
    "curvedArrow": "Gezi kurbatua",
    "curvedLine": "Lerro kurbatua",
    "documentation": "Dokumentazioa",
    "doubleClick": "klik bikoitza",
    "drag": "arrastatu",
    "editor": "Editorea",
    "editLineArrowPoints": "Editatu lerroak/gezi-puntuak",
    "editText": "Editatu testua / gehitu etiketa",
    "github": "Arazorik izan al duzu? Eman horren berri",
    "howto": "Jarraitu gure gidak",
    "or": "edo",
    "preventBinding": "Saihestu gezien gainjartzea",
    "tools": "Tresnak",
    "shortcuts": "Laster-teklak",
    "textFinish": "Bukatu edizioa (testu editorea)",
    "textNewLine": "Gehitu lerro berri bat (testu editorea)",
    "title": "Laguntza",
    "view": "Bistaratu",
    "zoomToFit": "Egin zoom elementu guztiak ikusteko",
    "zoomToSelection": "Zooma hautapenera",
    "toggleElementLock": "Blokeatu/desbloketatu hautapena",
    "movePageUpDown": "Mugitu orria gora/behera",
    "movePageLeftRight": "Mugitu orria ezker/eskuin",
    "cropStart": "Moztu irudia",
    "cropFinish": "Amaitu irudia mozten"
  },
  "clearCanvasDialog": {
    "title": "Garbitu oihala"
  },
  "imageExportDialog": {
    "header": "Esportatu irudia",
    "label": {
      "withBackground": "Atzeko planoa",
      "onlySelected": "Hautapena soilik",
      "darkMode": "Modu iluna",
      "embedScene": "Txertatu eszena",
      "scale": "Eskala",
      "padding": "Betegarria"
    },
    "tooltip": {
      "embedScene": "Eszenaren datuak esportatutako PNG/SVG fitxategian gordeko dira, eszena bertatik berrezartzeko.\nEsportatutako fitxategien tamaina handituko da."
    },
    "title": {
      "exportToPng": "Esportatu PNG gisa",
      "exportToSvg": "Esportatu SVG gisa",
      "copyPngToClipboard": "Kopiatu PNG arbelera"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopiatu arbelean"
    }
  },
  "encrypted": {
    "tooltip": "Zure marrazkiak muturretik muturrera enkriptatu dira, beraz Excalidraw-ren zerbitzariek ezingo dituzte ikusi.",
    "link": "Excalidraw-ren muturretik muturrerako enkriptatzearen gaineko mezua blogean"
  },
  "stats": {
    "angle": "Angelua",
    "shapes": "Formak",
    "height": "Altuera",
    "scene": "Eszena",
    "selected": "Hautatua",
    "storage": "Biltegia",
    "fullTitle": "Oihal eta formen propietateak",
    "title": "Propietateak",
    "generalStats": "Orokorra",
    "elementProperties": "Formaren propietateak",
    "total": "Guztira",
    "version": "Bertsioa",
    "versionCopy": "Klikatu kopiatzeko",
    "versionNotAvailable": "Bertsio ez eskuragarria",
    "width": "Zabalera"
  },
  "toast": {
    "copyStyles": "Estiloak kopiatu dira.",
    "copyToClipboard": "Arbelean kopiatu da.",
    "copyToClipboardAsPng": "{{exportSelection}} kopiatu da arbelean PNG gisa\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "Kopiatuta {{exportSelection}} arbelean SVG gisa\n({{exportColorScheme}})",
    "fileSaved": "Fitxategia gorde da.",
    "fileSavedToFilename": "{filename}-n gorde da",
    "canvas": "oihala",
    "selection": "hautapena",
    "pasteAsSingleElement": "Erabili {{shortcut}} elementu bakar gisa itsasteko,\nedo itsatsi lehendik dagoen testu-editore batean",
    "unableToEmbed": "Url hau txertatzea ez da une honetan onartzen. Sortu issue bat GitHub-en Urla zerrenda zurian sartzea eskatzeko",
    "unrecognizedLinkFormat": "Kapsulatu duzun esteka ez dator bat espero den formatuarekin. Mesedez, saiatu iturburu-guneak emandako 'kapsulatu' katea itsasten",
    "elementLinkCopied": "Esteka arbelean kopiatu da"
  },
  "colors": {
    "transparent": "Gardena",
    "black": "Beltza",
    "white": "Zuria",
    "red": "Gorria",
    "pink": "Arrosa",
    "grape": "Mahats kolorea",
    "violet": "Bioleta",
    "gray": "Grisa",
    "blue": "Urdina",
    "cyan": "Ziana",
    "teal": "Berde urdinxka",
    "green": "Berdea",
    "yellow": "Horia",
    "orange": "Laranja",
    "bronze": "Brontzea"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Zure marrazkiak zure nabigatzailearen biltegian gordetzen dira.",
      "center_heading_line2": "Nabigatzailearen biltegia ustekabean hustu daiteke.",
      "center_heading_line3": "Gorde zure lana maiz fitxategi batean, ez galtzeko.",
      "center_heading_plus": "Horren ordez Excalidraw+-era joan nahi al zenuen?",
      "menuHint": "Esportatu, hobespenak, hizkuntzak..."
    },
    "defaults": {
      "menuHint": "Esportatu, hobespenak eta gehiago...",
      "center_heading": "Diagramak. Egina. Sinplea.",
      "toolbarHint": "Aukeratu tresna bat eta hasi marrazten!",
      "helpHint": "Lasterbideak eta laguntza"
    }
  },
  "colorPicker": {
    "color": "Kolorea",
    "mostUsedCustomColors": "Gehien erabilitako kolore pertsonalizatuak",
    "colors": "Koloreak",
    "shades": "Ñabardurak",
    "hexCode": "Hez kodea",
    "noShades": "Kolore honetarako ez dago ñabardurarik eskuragarri",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Esportatu irudi gisa",
        "button": "Esportatu irudi gisa",
        "description": "Esportatu eszenaren datuak geroago inportatu ahal izango duzun irudi gisa."
      },
      "saveToDisk": {
        "title": "Gorde diskoan",
        "button": "Gorde diskoan",
        "description": "Esportatu eszenaren datuak geroago inportatu ahal izango duzun fitxategi batan."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Esportatu Excalidraw+ra",
        "description": "Gorde eszena zure Excalidraw+ laneko areara."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Fitxategitik kargatu",
        "button": "Fitxategitik kargatu",
        "description": "Fitxategi batetik kargatzeak <bold>lehendik duzun edukia ordezkatuko du</bold>.<br></br>Lehenengo marrazkiaren babeskopia egin dezakezu beheko aukeretako bat erabiliz."
      },
      "shareableLink": {
        "title": "Estekatik kargatu",
        "button": "Ordeztu nire edukia",
        "description": "Kanpoko irudi bat kargatzeak <bold>lehendik duzun edukia ordezkatuko du</bold>.<br></br>. Zure marrazkiaren babeskopia egin dezakezu lehenik beheko aukeretako bat erabiliz."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Bilaketa azkarra"
  },
  "fontList": {
    "badge": {
      "old": "zaharra"
    },
    "sceneFonts": "Eszena honetan",
    "availableFonts": "Letra mota erabilgarriak",
    "empty": "Ez da letra motarik aurkitu"
  },
  "userList": {
    "empty": "Ez da erabiltzailerik aurkitu",
    "hint": {
      "text": "Klik erabiltzailean jarraitzeko",
      "followStatus": "Dagoeneko erabiltzaile hau jarraitzen ari zara",
      "inCall": "Erabiltzailea dei batean dago",
      "micMuted": "Erabiltzailearen mikronofoa isildua dago",
      "isSpeaking": "Erabiltzailea hitz egiten ari da"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Aukera",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Sartu",
    "shift": "Mayus",
    "spacebar": "Zuriunea",
    "delete": "Ezabatu",
    "mmb": "Korritzeko gurpila"
  }
}
